<template>
  <div>
    <InfluencerDashboard />
  </div>
</template>

<script>
import InfluencerDashboard from '../components/Influencer/InfluencerDashboard.vue';

export default {
  components: { InfluencerDashboard },
  mounted() {
    this.auth();
  },
  methods: {
    auth() {
      this.axios.get(`${this.baseUrl}/dashboard/auth`, this.$store.getters.authHeader)
        .catch(() => {
          this.$router.push('/');
        });
    },
  },
};
</script>

<style>

</style>
